export default "<p>nurse-point-sale-product-service works!</p>\n"